import { forwardRef, useCallback } from "react";
import { ReactSVG } from "react-svg";
import { Loader } from "@progress/kendo-react-indicators";

export const SafeSVG = forwardRef(function SafeSvg(props, ref) {
  const { src, alt, className, fallback, ...rest } = props || {};

  const handleError = useCallback((error) => {
    console.error(`Nepodarilo sa načítať SVG: ${src}`);
  }, []);

  const handleBeforeInjection = useCallback((svg) => {
    if (alt) {
      svg.setAttribute("role", "img");
      svg.setAttribute("aria-label", alt);
    }
  }, [alt]); // keď sa zmení alt, callback sa vytvorí znova

  const handleFallback = useCallback(
    () => fallback || <DefaultFallbackIcon alt={alt} />,
    [fallback, alt]
  );

  const handleLoading = useCallback(
    () => <Loader size="small" type="converging-spinner" />,
    []
  );

  // nič nevykreslíme, ak src nie je zadané
  if (!src) {
    return null;
  }

  return <ReactSVG
    src={src}
    loading={handleLoading}
    onError={handleError}
    className={className}
    ref={ref}
    fallback={handleFallback}
    beforeInjection={handleBeforeInjection}
    {...rest}
  />;
});

export const DefaultFallbackIcon = ({ alt }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label={alt || "Ikona sa nepodarila načítať"}
    role="img"
    focusable="false"
    style={{ pointerEvents: "none", display: "inline-block" }}
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="var(--ci-on-surface, #373A46)" />
    <line x1="3" y1="3" x2="21" y2="21" stroke="var(--ci-error, #ED1C24)" />
  </svg>
);